/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester*/
import React from 'react';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import HeaderCarrousel from '../shared/carrousels/HeaderCarrousel';
import * as pageStyles from '../../styles/internal-page/internal-page.module.scss';
import {altNN} from '../../utils/parsing';
import HeaderVideo from '../shared/HeaderVideo';

const ContentTop = React.memo(function ContentTop ({
  carrousel, cover, siteURL, locale, headerVideo
}) {
  return (
    <>
      {cover && (
        <GatsbyImage
          alt={altNN('')}
          className={pageStyles.coverImageInternalPage}
          image={getImage(cover.imageFile)}
          loading="eager"
        />
      )}
      {carrousel && (
        <div className={pageStyles.innerInternalPage}>
          <HeaderCarrousel
            color={carrousel.color}
            id={carrousel.id}
            items={carrousel.carousel_item}
            locale={locale}
            siteURL={siteURL}
          />
        </div>
      )}
      {headerVideo && (
        <HeaderVideo {...headerVideo}/>
      )}
    </>
  );
});

ContentTop.propTypes = {
  carrousel: PropTypes.shape({
    id: PropTypes.string.isRequired,
    carousel_item: PropTypes.array.isRequired,
    color: PropTypes.string,
  }),
  cover: PropTypes.shape({
    imageFile: PropTypes.object.isRequired,
  }),
  headerVideo: PropTypes.object,
  locale: PropTypes.string,
  siteURL: PropTypes.string,
};

export default ContentTop;
